var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2501 10.8333H9.58341C9.35341 10.8333 9.16675 10.6467 9.16675 10.4167C9.16675 10.1867 9.35341 10 9.58341 10H16.2501C16.4801 10 16.6667 10.1867 16.6667 10.4167C16.6667 10.6467 16.4801 10.8333 16.2501 10.8333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5834 15.0001H9.58341C9.35341 15.0001 9.16675 14.8134 9.16675 14.5834C9.16675 14.3534 9.35341 14.1667 9.58341 14.1667H19.5834C19.8134 14.1667 20.0001 14.3534 20.0001 14.5834C20.0001 14.8134 19.8134 15.0001 19.5834 15.0001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2501 19.1666H9.58341C9.35341 19.1666 9.16675 18.9799 9.16675 18.7499C9.16675 18.5199 9.35341 18.3333 9.58341 18.3333H16.2501C16.4801 18.3333 16.6667 18.5199 16.6667 18.7499C16.6667 18.9799 16.4801 19.1666 16.2501 19.1666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7501 6.66663H10.4167C9.72758 6.66663 9.16675 6.10579 9.16675 5.41663V2.91663C9.16675 2.22746 9.72758 1.66663 10.4167 1.66663H18.7501C19.4393 1.66663 20.0001 2.22746 20.0001 2.91663V5.41663C20.0001 6.10579 19.4393 6.66663 18.7501 6.66663ZM10.4167 2.49996C10.1867 2.49996 10.0001 2.68663 10.0001 2.91663V5.41663C10.0001 5.64663 10.1867 5.83329 10.4167 5.83329H18.7501C18.9801 5.83329 19.1668 5.64663 19.1668 5.41663V2.91663C19.1668 2.68663 18.9801 2.49996 18.7501 2.49996H10.4167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08333 4.58333H0.416667C0.186667 4.58333 0 4.39667 0 4.16667C0 3.93667 0.186667 3.75 0.416667 3.75H7.08333C7.31333 3.75 7.5 3.93667 7.5 4.16667C7.5 4.39667 7.31333 4.58333 7.08333 4.58333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.74988 7.91673C3.64322 7.91673 3.53655 7.8759 3.45488 7.79507C3.29238 7.63257 3.29238 7.3684 3.45488 7.2059L6.49405 4.16673L3.45488 1.1284C3.29238 0.9659 3.29238 0.701733 3.45488 0.539233C3.61738 0.376733 3.88155 0.376733 4.04405 0.539233L7.37738 3.87257C7.53988 4.03507 7.53988 4.29923 7.37738 4.46173L4.04405 7.79507C3.96322 7.8759 3.85655 7.91673 3.74988 7.91673Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextInput);
export default __webpack_public_path__ + "static/media/text-input.9420a511edb7563db778191c969b998f.svg";
export { ForwardRef as ReactComponent };